/*
 * @Descripttion: checkbox多选组件
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */

import React, { useState } from 'react';
import { Checkbox } from '@alifd/next';
import LzMessage from '@/components/common/LzMessage';
import styles from './index.module.scss';

/**
 * opType 固定为 'ALL'
 * @param {*} tagItem 整个标签的信息
 * @param {*} changeData 把组件的值提交到父组件，改变父组件的值
 * @return {*}
 */
const TagCheckbox = ({
  tagItem = {}, changeData = (data) => {
  },
}) => {
  const limitObj = {
    '短视频一级类目偏好': 5,
    '短视频二级类目偏好': 38,
    '短视频三级类目偏好': 58,
  }
  const [data, setData] = useState(tagItem?.opValue?.param_list?.[0]?.param_id ?? []); // checkbox组选中的值

  const [valueList, setValueList] = useState(tagItem?.value ?? []); // checkbox组所展示的可选值列表, 如果有 interface 证明这是个需要走接口获取枚举的组件，需要先调一下

  /**
   * 选择时传给父组件
   */
  const changeValue = (val) => {
    if(limitObj[tagItem.labelName] && val.length > limitObj[tagItem.labelName]) {
      LzMessage.error('最多只能选择' + limitObj[tagItem.labelName] + '个' + tagItem.labelName, '');
      return ;
    } else {
      setData(val);
      changeData({
        opValue: {
          label_id: tagItem.id,
          param_list: [
            {
              param_id: val
            }
          ]
        },
        opType: 'ALL'
      });
    }
  };

  return (
    <div className={`${styles['tag-checkbox']} tag-width`}>
      <Checkbox.Group value={data} onChange={(val) => changeValue(val)}>
        {
          valueList.map((its, ins) => (<Checkbox
            style={{ marginBottom: '10px', marginLeft: '0px', marginRight: '8px' }}
            key={ins}
            value={its.realValue}
          >
            {its.fieldValue}
          </Checkbox>))
        }
      </Checkbox.Group>
      {
        data.length <= 0 && <div style={{ color: "#f33" }}
          className={`iconfont icon-icon4-30 ${styles['tag-error-select']}`}
        >请选择{tagItem.labelDescription}
        </div>
      }
    </div>
  );
};
export default TagCheckbox;
